import React from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { TakeOffActionsProps } from "./types";
import { useTakeOffMutation } from "@src/features/order/redux";
import { ArcButton, ArcStack } from "@src/core/ui";
import { CancelMissionOrderButton, ModifyMissionOrderButton } from '@src/features/order/components';
import { toast } from 'react-toastify';
import { routesConfig } from '@src/core/routes';
import { SETTING_UNITS_KEY } from '@src/core/config';
import { UnitType, UnitSystemType } from '@src/core/enums';

const TakeOffActions: React.FC<TakeOffActionsProps> = (props) => {
  const { isAgree, droneSerial, orderId } = props;
  const navigate = useNavigate();
  const { missionId } = useParams();
  const [takeOff, { isLoading }] = useTakeOffMutation();

  const onTakeOff = () => {
    if (missionId) {
      const unitSystem = localStorage.getItem(SETTING_UNITS_KEY) === UnitType.SI ? UnitSystemType.METRIC : UnitSystemType.IMPERIAL;
      takeOff({ missionId, unitSystem }).unwrap().then(() => {
        navigate(`${routesConfig.drones}/?droneSerial=${droneSerial}&orderId=${orderId}`);
        toast.success('Take Off Success Text');
      }).catch(() => {});
      return;
    }
    toast.error('missionId is undefined');
  };

  if (!missionId) return null;
  
  return (
    <ArcStack spacing={1}>
      <ArcStack spacing={1}>
        <ArcStack direction='row' spacing={1}>
          <ModifyMissionOrderButton missionId={missionId} />
          <CancelMissionOrderButton missionId={missionId} successCallback={() => navigate(routesConfig.orders)} />
        </ArcStack>
        <ArcButton.brand 
          disabled={!isAgree}
          isLoading={isLoading} 
          onClick={onTakeOff}> 
          Take Off 
        </ArcButton.brand>
      </ArcStack>

    </ArcStack>
  );
};

export default TakeOffActions;